/** 
 * @namespace Search
 * @memberof Promega.Shell
 * @description Methods for calling Promega.com search APIs.
 */

const disallowedSearchHosts = ["prototype.promega.com", "localhost"];
let certificatesUrl = "/services/widenlookupservice.svc/",
    groupFilterUrl = "/services/products.ashx",
    requestCredentials = "same-origin",
    COVEO_SEARCH_BOX_CLASS_NAME = "CoveoOmnibox";

// API

/**
 * @function isSearchHostDisallowed
 * @memberof Promega.Shell.Search
 * @description Returns a value indicating whether or not a search can be performed in the given host.
 * @param {String} searchHost The host to check
 * @returns {Boolean}
 * @deprecated No longer used after the rollout of Coveo search on the site.
 */
export function isSearchHostDisallowed(searchHost) {
    return disallowedSearchHosts.indexOf(searchHost) > -1;
}

/**
 * @function getCertificatesOfAnalysis
 * @memberof Promega.Shell.Search
 * @description Requests a list of certificates of analysis for the given catalog number and lot number.
 * @param {String} catNum A catalog number
 * @param {String} lotNum A lot number
 * @param @deprecated {Function} successCallback A function to call if the request succeeds
 * @param @deprecated {Function} failureCallback A function to call if the request fails
 * @returns {Promise}
 */
export function getCertificatesOfAnalysis(catNum, lotNum, successCallback, failureCallback) {
    return new Promise((resolve, reject) => {
        if (catNum) {
            let queryUrl = certificatesUrl + "?catNum=" + catNum;
            if (lotNum) queryUrl += "&lotNum=" + lotNum;
            fetch(queryUrl, { credentials: requestCredentials }).then(response => response.json()).then(result => {
                successCallback && successCallback(result);
                resolve(result.SearchForCertificateofAnalysisResult);
            }).catch(error => {
                failureCallback && failureCallback(error);
                reject(error);
            });
        }
    });
}

/**
 * @function getProductsByGroup
 * @memberof Promega.Shell.Search
 * @description Requests a list of products for the group with the given Sitecore item ID.
 * @param {String} groupId A Sitecore item ID
 * @param {JSON} options
 * @param {Number} options.index The index at which to start returning results
 * @param {Number} options.count The number of results to request
 * @param {String} options.sort The type of sorting to request
 * @param {Array<String>} options.filters An array of Sitecore item IDs representing the selected filters
 * @param {Function} successCallback A function to call if the request succeeds
 * @param {Function} failureCallback A function to call if the request fails
 */
export function getProductsByGroup (groupId, options, successCallback, failureCallback) {
    if (groupId && successCallback) {
        let queryUrl = groupFilterUrl + "?group=" + groupId;
        if (options) {
            if (options.index) queryUrl += "&index=" + options.index;
            if (options.count) queryUrl += "&count=" + options.count;
            if (options.sort) queryUrl += "&sort=" + options.sort;
            if (options.filters && options.filters.length > 0) {
                queryUrl += "&filters=";
                for (let i=0; i<options.filters.length; i++) {
                    if (i>0) queryUrl += ",";
                    queryUrl += options.filters[i];
                }
            }
        }
        fetch(queryUrl, {credentials: requestCredentials}).then((response) => response.json()).then(successCallback).catch(failureCallback);
    }
}

/*
* Gets the searchbox element in use
*/
export function getSearchBox() {
    return document.querySelector(`.${COVEO_SEARCH_BOX_CLASS_NAME} input`);
}

// Init code

if (typeof window !== "undefined") {
    // Check for dev environment
    if (isSearchHostDisallowed(location.host)) {
        certificatesUrl = location.protocol + "//www.promega.com" + certificatesUrl;
        groupFilterUrl = location.protocol + "//dev.promega.com" + groupFilterUrl;
        requestCredentials = "include";
    }
}
    